import React from 'react';

import BgLogo from 'assets/images/favicon.ico';

function LogoFaded() {
  return (
    <>
      <img
        src={BgLogo}
        className="fixed top-0 left-0 h-screen opacity-5"
        alt="bg-logo"
        style={{
          zIndex: -1,
        }}
      />
    </>
  );
}

LogoFaded.propTypes = {};

export default LogoFaded;
